module.exports = __webpack_public_path__ + "img/logo_icon_2x.212afa14.png";